import React from 'react'
import styles from './Icon.scss'
import cx from 'classnames'

const context = require.context('assets/icons/', false, /\.svg$/)
const icons = {}
context.keys().forEach(k => { icons[k.slice(2, -4)] = context(k) })

// export const Icon = ({ i, className, size, style, ...props }) => (
export const Icon = React.forwardRef(({ i, className, size, style, ...props }, ref) => (
  <span {...props}
    ref={ref}
    className={cx(styles.Icon, size && styles.hasSize, className)}
    style={{ ...style, fontSize: size }}
    dangerouslySetInnerHTML={{ __html: icons[i] }} />
))
